import { render } from "./RoleTable.vue?vue&type=template&id=48032a6d&scoped=true&ts=true"
import script from "./RoleTable.vue?vue&type=script&lang=ts"
export * from "./RoleTable.vue?vue&type=script&lang=ts"

import "./RoleTable.vue?vue&type=style&index=0&id=48032a6d&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48032a6d"]])

export default __exports__